export default __webpack_public_path__ + "static/media/student-profile-summary.1ed91458.png";